exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-group[data-v-7df050da] {\n  border-bottom: none;\n}\n", ""]);

// exports
